module.exports = __webpack_public_path__ + "img/navigation-icon.13cb0443.png";